// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3gBDx","content":"styles_content__2OIjh"};